export default {"src":"/_next/static/media/mailing-list-hero.eda40577.svg","height":204,"width":400,"blurWidth":0,"blurHeight":0};